<template>
  <div class="ts-space-y-3">
    <div class="ts-space-x-3 ts-flex ts-justify-end">
      <ts-button
        :waiting="waiting_approve"
        :disabled="disabledButton"
        color="primary"
        @click="approve"
        >{{ $t('approvalRequest.approve') }}</ts-button
      >
      <ts-button color="danger" @click="onReject" :disabled="disabledButton">{{
        $t('approvalRequest.reject')
      }}</ts-button>
    </div>
    <ts-loading-banner :loading="loading">
      <table class="ts-w-full">
        <thead>
          <tr class="ts-bg-gray-200">
            <th
              class="ts-text-center ts-w-2 ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky"
              valign="middle"
            >
              #
            </th>
            <th
              class="ts-text-center ts-w-2 ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky"
              valign="middle"
            >
              <input
                type="checkbox"
                class="ts-mb-0"
                :checked="checkAll"
                @change="onCheckAll"
              />
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.planDate') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.dealerCode') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.dealerName') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.dealerContactNumber') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.requestBy') }}
            </th>
            <th class="ts-px-3 ts-py-1 ts-uppercase ts-top-0 ts-sticky">
              {{ $t('approvalRequest.reason') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="ts-border-b" v-for="(r, index) in resources" :key="index">
            <td class="ts-px-3 ts-py-1 ts-text-center">{{ index + 1 }}</td>
            <td class="ts-px-3 ts-py-1">
              <input
                type="checkbox"
                class="ts-mb-0"
                v-model="model.request_id_list"
                :value="r.request_id"
              />
            </td>
            <td class="ts-px-3 ts-py-1">{{ r.plan_date }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.customer_code }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.customer_name }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.contact_number }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.request_by_name }}</td>
            <td class="ts-px-3 ts-py-1">{{ r.reason }}</td>
          </tr>
        </tbody>
      </table>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import Comment from './comment.vue'
export default {
  name: 'pendingList',
  data() {
    return {
      loading: false,
      waiting_approve: false,
      rejecting: false,
      resources: [],
      errors: new Errors(),
      model: {
        request_id_list: [],
        app_type_id: 5, // approve for re-check-in
        app_status: null,
        app_comments: null
      }
    }
  },
  computed: {
    checkAll() {
      if (this.resources.length) {
        return this.model.request_id_list.length == this.resources.length
      }
      return false
    },
    disabledButton() {
      return !this.model.request_id_list.length
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('hr/approvalRequest', ['store']),
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('hr/approvalRequest/fetchReCheckIn', {
          filter: {
            app_type_id: '5',
            approve_status: 0
          },
          perPage: -1
        })
        .then(response => {
          this.loading = false
          this.resources = response.data
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onCheckAll(e) {
      if (e.target.checked) {
        this.model.request_id_list = this.resources.map(el => el.request_id)
      } else {
        this.model.request_id_list = []
      }
    },
    approve() {
      this.waiting_approve = true
      this.errors = new Errors()
      this.model.app_status = 2
      this.store(this.model)
        .then(async response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_approve = false
        })
    },
    onReject() {
      this.model.app_status = 3
      this.$confirm({
        centered: true,
        okType: 'danger',
        title: this.$t('approvalRequest.are_you_sure_to_reject'),
        content: h =>
          h(Comment, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('approvalRequest.comment')
            }
          }),
        onOk: () => {
          return this.store(this.model)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        cancelText: this.$t('no'),
        okText: this.$t('yes'),
        onCancel: () => {
          this.model.app_status = null
        }
      })
    }
  }
}
</script>
